import { render } from "./grouppermissions.vue?vue&type=template&id=8b80981e"
import script from "./grouppermissions.vue?vue&type=script&lang=js"
export * from "./grouppermissions.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-AfyunProd\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__